module.exports = __webpack_public_path__ + "static/media/scubaman.dc79d5c5.png";